import { applyMiddleware } from "satcheljs";
import type { Middleware } from "satcheljs";

const cachedMiddleware: Middleware[] = [];

export function addNewMiddleWare(middlewares: Middleware[]): void {
    for (const middleware of middlewares) {
        cachedMiddleware.push(middleware);
    }
    
    applyMiddleware.apply(null, cachedMiddleware);
}
